export default __webpack_public_path__ + "static/netspy-logo-839b6fd2727045c437030c37a3af17f8.svg";